export default "__VITE_ASSET__CVQnh9Vx__"